export const capitalizeFirstLetter = (string?: string | null) =>
  !string ? string : string.charAt(0).toUpperCase() + string.slice(1)
